/* src/app/modules/invoice/tickets/ticket-dialog-total.component.css */
.tt-header-text {
  min-width: 0;
  padding-right: 32px;
}
.tt-range {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.tt-help {
  margin: 0 0 12px;
  font-size: 13px;
  color: #6b7280;
}
.tt-range-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  font-size: 13px;
  color: #6b7280;
}
.tt-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.tt-kpi {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}
.tt-kpi--highlight {
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-color: #e5f3a0;
}
.tt-kpi__label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #6b7280;
}
.tt-kpi__value {
  font-size: 18px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.tt-kpi__value--success {
  color: #16a34a;
}
.tt-kpi__value--warning {
  color: #d97706;
}
.tt-table-wrap {
  max-height: 40vh;
  overflow: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.tt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.tt-table th {
  position: sticky;
  top: 0;
  background: #f4f6f8;
  color: #6b7280;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  text-align: left;
  padding: 8px 12px;
  z-index: 1;
}
.tt-table td {
  padding: 8px 12px;
  color: #2f3540;
  border-top: 1px solid #eef1f4;
  white-space: nowrap;
}
.tt-num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
}
.tt-empty {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #6b7280;
}
.tt-empty mat-icon {
  flex-shrink: 0;
}
/*# sourceMappingURL=ticket-dialog-total.component.css.map */
